module.exports = __webpack_public_path__ + "static/media/greenblue.e2b19781.png";